/**
 * 纪要模块
 */
import { PAGE_LEVEL } from '@/constants';

export default {
  meta: { localeModules: ['summary', 'aiChat', 'cloudDocument', 'question', 'report', 'roadshow'] },
  path: '/summary',
  redirect: '/summary/list',
  children: [
    {
      path: 'list',
      name: 'summaryList',
      component: () => import(/* webpackChunkName: 'market-research-summary' */ '@/pages/marketResearch/summary.vue'),
      meta: {
        name: 'routers.summary_summary',
        componentName: 'SummaryListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 路演详情
      path: 'detail',
      name: 'summaryDetail',
      component: () => import(/* webpackChunkName: 'roadshow-summary-detail' */ '@/pages/roadshow/detail.vue'),
      meta: {
        parent: '/summary/list',
        pageLevel: PAGE_LEVEL.SECOND
      }
    },
    {
      path: 'summaryDetail',
      name: 'researchSummaryDetail',
      component: () =>
        import(/* webpackChunkName: 'summary-detail' */ '@/pages/marketResearch/tabs/summary/summaryDetailPage.vue'),
      meta: {
        name: 'routers.summary_summary_detail',
        parent: '/summary/list',
        pageLevel: PAGE_LEVEL.SECOND,
        allowMenuBack: true,
        electronSingle: true
      }
    }
  ]
};
